import type { GetVideoParams, GetVideoResult } from 'src/types';
import { useQuery } from '@tanstack/react-query';
import { videos } from 'admin/resources';
import { useAdminSelector } from 'admin/reducers';
import { selectActiveOrganizationId } from 'admin/reducers/user/selectors';
import { videoKeys } from '../queryKeys';

export const getVideoQueryFn = async ({ organizationId, videoId }: GetVideoParams) => {
	const response: ApiV2Response<GetVideoResult> = await videos.getById.params({ organizationId, videoId }).send();
	return response.body;
};

export const useVideo = (params: Omit<GetVideoParams, 'organizationId'>, options?: { enabled?: boolean }) => {
	const organizationId = useAdminSelector(selectActiveOrganizationId);
	const { videoId } = params;
	const enabled = options?.enabled ?? true;

	return useQuery({
		queryKey: videoKeys.detail({ organizationId, videoId }),
		queryFn: () => getVideoQueryFn({ organizationId, videoId }),
		enabled: Boolean(videoId) && enabled,
		select: data => data?.transcoding,
	});
};
